<template>
  <div class="navigation-sidebar" v-if="hasNavigation || hasViewTemplates">
    <Dropdown v-if="hasNavigation" showClear :placeholder="navigationTitle" optionLabel="Name" v-model="navigationDropdown" :options="navigationFilters" />
    <Dropdown v-if="hasViewTemplates" showClear :placeholder="viewTemplatesTitle" optionLabel="Name" v-model="viewTemplatesDropdown" :options="viewTemplatesDefinitions" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex/dist/vuex.cjs.js';
import Dropdown from 'primevue/dropdown';

export default {
  name: "NavigationSidebar",

  components: { Dropdown },

  computed: {
    ...mapState('general', ['selectedNavigationFilter', 'selectedViewTemplate']),
    ...mapState('settings', ['navigationConfig', 'viewTemplatesConfig']),
    
    navigationDropdown: {
      get() {
        return this.selectedNavigationFilter;
      }
      ,
      set(value) {
        this.changeSelectedNavigationFilter(value);
      }
    },

    viewTemplatesDropdown: {
      get() {
        return this.selectedViewTemplate;
      }
      ,
      set(value) {
        this.changeSelectedViewTemplate(value);
      }
    },

    hasNavigation() {
      if (this.$route.name != "2D") return false;
      if (this.navigationConfig && this.navigationConfig.Filters && this.navigationConfig.Filters.length > 0) {
        return true;
      }
      return false;
    },

    navigationTitle() {
      return this.navigationConfig.Name || "Navigation";
    },

    navigationFilters() {
      return this.navigationConfig.Filters || [];
    },

    hasViewTemplates() {
      if (this.$route.name != "2D") return false;
      if (this.viewTemplatesConfig && this.viewTemplatesConfig.Definitions && this.viewTemplatesConfig.Definitions.length > 0) {
        return true;
      }
      return false;
    },

    viewTemplatesTitle() {
      return this.viewTemplatesConfig.Name || "View Templates";
    },

    viewTemplatesDefinitions() {
      return this.viewTemplatesConfig.Definitions || [];
    },
  },

  methods: {
    ...mapActions('general', ['changeSelectedNavigationFilter', 'changeSelectedViewTemplate']),

    selectFilter(filter) {
      if (this.selectedNavigationFilter && this.selectedNavigationFilter == filter) {
        this.changeSelectedNavigationFilter(null);
      } else {
        this.changeSelectedNavigationFilter(filter);
      }
    },

    selectViewTemplate(template) {
      if (this.selectedViewTemplate && this.selectedViewTemplate == template) {
        this.changeSelectedViewTemplate(null);
      } else {
        this.changeSelectedViewTemplate(template);
      }
    },
  }
};
</script>

<style scoped lang="scss">
.navigation-sidebar {
  top: 0;
  left: 0;
  position: absolute;

  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
  // z-index: 1;
  width: 220px;
}
</style>